import { Component, Input, OnChanges, SimpleChanges, inject } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { DocumentModel } from "@models/documents/documentmodel";
import { isGuid } from "@methods/uniqueMethods";
import { DocumentDataService } from "@services/http/document/DocumentDataService";
import { DateTimeFormatPipe } from "@app/shared/pipes/date-time-format.pipe";
import { FileSizePipe } from "@app/shared/pipes/file-size.pipe";

@Component({
    selector: "document-history",
    templateUrl: "./document-history.component.html",
    styleUrls: ["./document-history.component.scss"],
    imports: [MatExpansionModule, TooltipModule, DateTimeFormatPipe, FileSizePipe]
})
export class DocumentHistoryComponent implements OnChanges {
    private _docDS = inject(DocumentDataService);

    @Input() guid: string;
    documentHistory: DocumentModel[];

    ngOnChanges(changes: SimpleChanges): void {
        const change = changes["guid"];
        if (isGuid(change.currentValue) && change.currentValue !== change.previousValue) {
            this.loadHistory();
        }
    }

    loadHistory() {
        this._docDS.GetDocumentHistory(this.guid).then((history) => {
            this.documentHistory = history;
        });
    }
}
